import React, { Component, Fragment } from 'react';
import { Button, Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';

import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { ASSIGN_ENTITIES_FORM_NAME } from 'Common/FormEnum';
import { AssignEntitiesEnum } from 'Common/FieldEnum';
import { SelectField } from 'Common/SemanticWrapper';

import {
  DropdownOptions,
  SortOptions,
  getComponentOnSelection,
  GridResetInitialValueEnum,
  ComponentMapping,
  GridNames,
} from '../../../helper/assignEntities';
import ItemGridFilterComponent from '../../components/storageLocation/ItemGridFilter';
import { clearItemGridFilter } from '../../../state/assignEntities/actions';
import * as Selectors from '../../../state/assignEntities/selectors';

class AssignOrderingSiteHeader extends Component {
  static propTypes = {
    fields: PropTypes.array.isRequired,
    clearItemGridFilter: PropTypes.func.isRequired,
    changeGrid: PropTypes.func,
    changeDirection: PropTypes.func,
    clearFilter: PropTypes.func,
    handleDropDownChange: PropTypes.func,
    onResetPageOnDataChange: PropTypes.func,
    direction: PropTypes.bool,

    sortOptionsValue: PropTypes.string.isRequired,
    dropDownValue: PropTypes.string.isRequired,
    loadingAllSites: PropTypes.bool.isRequired,
    loadingAllItems: PropTypes.bool.isRequired,
    loadingSiteGroup: PropTypes.bool.isRequired,
  };
  static defaultProps = {
    direction: true,
    changeGrid: () => {},
    changeDirection: () => {},
    clearFilter: () => {},
    handleDropDownChange: () => {},
    onResetPageOnDataChange: () => {},
  };

  state = {
    activeIndexes: [0],
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexes } = this.state;
    const activeIndexesClone = [...this.state.activeIndexes];
    activeIndexes.indexOf(index) !== -1
      ? activeIndexesClone.splice(activeIndexes.indexOf(index), 1)
      : activeIndexesClone.push(index);
    this.setState({ activeIndexes: activeIndexesClone });
  };

  clearItemGridFilter = () => {
    const { direction, sortOptionsValue, dropDownValue } = this.props;
    this.props.clearItemGridFilter();
    const renderedComponent = getComponentOnSelection(
      sortOptionsValue,
      dropDownValue,
      direction
    );
    if (
      renderedComponent === ComponentMapping.SiteToItemsComponents ||
      renderedComponent === ComponentMapping.SiteGroupToItemsComponents
    ) {
      this.props.onResetPageOnDataChange({
        ...GridResetInitialValueEnum,
        [GridNames.Site]: false,
      });
    } else if (
      renderedComponent === ComponentMapping.ItemToSitesComponents ||
      renderedComponent === ComponentMapping.ItemToSiteGroupsComponents
    ) {
      this.props.onResetPageOnDataChange({
        ...GridResetInitialValueEnum,
        [GridNames.Item]: true,
        [GridNames.Site]: false,
      });
    }
  };

  render() {
    const {
      sortOptionsValue,
      dropDownValue,
      loadingAllSites,
      changeGrid,
      loadingAllItems,
      loadingSiteGroup,
      direction,
      changeDirection,
      clearFilter,
      fields,
      handleDropDownChange,
    } = this.props;
    return (
      <Grid>
        {direction ? (
          <Fragment>
            <Grid.Row>
              <Grid.Column>Assign Ordering Site</Grid.Column>
            </Grid.Row>
            <Grid.Row columns={5}>
              <Grid.Column
                width={2}
                verticalAlign={'top'}
                textAlign={'right'}
                style={{
                  paddingRight: '0 !important',
                  marginTop: 10,
                }}
              >
                List By
              </Grid.Column>
              <Grid.Column width={4} verticalAlign={'bottom'}>
                <ReduxFormButtonGroup
                  options={SortOptions}
                  value={sortOptionsValue}
                  formName={ASSIGN_ENTITIES_FORM_NAME}
                  fieldName={AssignEntitiesEnum.SortOptions}
                  type={'button'}
                  onChange={value => {
                    changeGrid(
                      getComponentOnSelection(value, dropDownValue, direction)
                    );
                  }}
                />
              </Grid.Column>
              <Grid.Column width={2} verticalAlign={'top'}>
                <Button
                  icon={'exchange'}
                  size={'large'}
                  fluid
                  type={'button'}
                  disabled={
                    loadingAllSites || loadingSiteGroup || loadingAllItems
                  }
                  loading={
                    loadingAllSites || loadingSiteGroup || loadingAllItems
                  }
                  onClick={() => {
                    changeGrid(
                      getComponentOnSelection(
                        sortOptionsValue,
                        dropDownValue,
                        !direction
                      )
                    );
                    changeDirection();
                  }}
                />
              </Grid.Column>
              <Grid.Column width={4} verticalAlign={'top'}>
                <Field
                  name={AssignEntitiesEnum.To}
                  component={SelectField}
                  options={DropdownOptions}
                  value={dropDownValue}
                  type="text"
                  onChange={(e, newValue) => {
                    changeGrid(
                      getComponentOnSelection(
                        sortOptionsValue,
                        newValue,
                        direction
                      )
                    );
                  }}
                />
              </Grid.Column>
              <Grid.Column width={1} />
              <Grid.Column
                width={3}
                verticalAlign={'top'}
                floated={'right'}
                textAlign={'right'}
              >
                <Button content="Reset" type={'button'} onClick={clearFilter} />
              </Grid.Column>
            </Grid.Row>
            {dropDownValue === AssignEntitiesEnum.Users ? null : (
              <ItemGridFilterComponent
                handleClick={this.handleClick}
                handleDropDownChange={handleDropDownChange}
                direction={direction}
                fields={fields}
                clearFilter={this.clearItemGridFilter}
                activeIndexes={this.state.activeIndexes}
              />
            )}
          </Fragment>
        ) : (
          <Fragment>
            <Grid.Row columns={2}>
              <Grid.Column width={8} />
              <Grid.Column width={8}>Assign Ordering Site</Grid.Column>
            </Grid.Row>
            <Grid.Row columns={6}>
              <Grid.Column width={4} verticalAlign={'top'}>
                <Field
                  name={AssignEntitiesEnum.To}
                  component={SelectField}
                  options={DropdownOptions}
                  value={dropDownValue}
                  type="text"
                  onChange={(e, newValue) => {
                    changeGrid(
                      getComponentOnSelection(
                        sortOptionsValue,
                        newValue,
                        direction
                      )
                    );
                  }}
                />
              </Grid.Column>
              <Grid.Column width={1} />
              <Grid.Column width={2} verticalAlign={'top'}>
                <Button
                  icon={'exchange'}
                  size={'large'}
                  fluid
                  type={'button'}
                  disabled={
                    loadingAllSites || loadingSiteGroup || loadingAllItems
                  }
                  loading={
                    loadingAllSites || loadingSiteGroup || loadingAllItems
                  }
                  onClick={() => {
                    changeGrid(
                      getComponentOnSelection(
                        sortOptionsValue,
                        dropDownValue,
                        !direction
                      )
                    );
                    changeDirection();
                  }}
                />
              </Grid.Column>

              <Grid.Column
                width={2}
                verticalAlign={'top'}
                textAlign={'right'}
                style={{
                  marginTop: 10,
                  paddingRight: '0px !important!',
                }}
              >
                List By
              </Grid.Column>
              <Grid.Column width={4} verticalAlign={'top'}>
                <ReduxFormButtonGroup
                  options={SortOptions}
                  value={sortOptionsValue}
                  formName={ASSIGN_ENTITIES_FORM_NAME}
                  fieldName={AssignEntitiesEnum.SortOptions}
                  type={'button'}
                  onChange={value => {
                    changeGrid(
                      getComponentOnSelection(value, dropDownValue, direction)
                    );
                  }}
                />
              </Grid.Column>
              <Grid.Column width={3} verticalAlign={'top'} floated={'right'}>
                <Button content="Reset" type={'button'} onClick={clearFilter} />
              </Grid.Column>
            </Grid.Row>
            {dropDownValue === AssignEntitiesEnum.Users ? null : (
              <ItemGridFilterComponent
                handleClick={this.handleClick}
                handleDropDownChange={handleDropDownChange}
                direction={direction}
                fields={fields}
                clearFilter={this.clearItemGridFilter}
                activeIndexes={this.state.activeIndexes}
              />
            )}
          </Fragment>
        )}
      </Grid>
    );
  }
}

const selector = formValueSelector(ASSIGN_ENTITIES_FORM_NAME);
const mapStateToProps = state => {
  return {
    sortOptionsValue: selector(state, AssignEntitiesEnum.SortOptions),
    dropDownValue: selector(state, AssignEntitiesEnum.To),
    loadingAllSites: Selectors.getLoadingAllSites(state),
    loadingAllItems: Selectors.getLoadingAllItems(state),
    loadingSiteGroup: Selectors.getLoadingSiteGroup(state),
  };
};

export const AssignOrderingSiteHeaderContainer = connect(
  mapStateToProps,
  {
    clearItemGridFilter,
  }
)(AssignOrderingSiteHeader);



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/containers/assignEntities/AssignOrderingSiteHeader.js